import { render, staticRenderFns } from "./AppealSignedSuccess.vue?vue&type=template&id=0cb34020&scoped=true&lang=pug&"
import script from "./AppealSignedSuccess.vue?vue&type=script&lang=js&"
export * from "./AppealSignedSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AppealSignedSuccess.vue?vue&type=style&index=0&id=0cb34020&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb34020",
  null
  
)

export default component.exports